import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TechnicianCard = ({ 
  technician, 
  onAssignOrder, 
  onViewDetails,
  onDeleteTechnician,
  isDragOver = false,
  selectedOrders = [],
  onAssignmentComplete
}) => {

  const getStatusColor = (status) => {
    switch (status) {
      case 'available':
        return 'bg-success text-success-foreground';
      case 'busy':
        return 'bg-warning text-warning-foreground';
      case 'offline':
        return 'bg-muted text-muted-foreground';
      default:
        return 'bg-secondary text-secondary-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'available':
        return 'CheckCircle';
      case 'busy':
        return 'Clock';
      case 'offline':
        return 'XCircle';
      default:
        return 'User';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'available':
        return 'Verfügbar';
      case 'busy':
        return 'Beschäftigt';
      case 'offline':
        return 'Offline';
      default:
        return 'Unbekannt';
    }
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    const orderData = JSON.parse(e?.dataTransfer?.getData('text/plain'));
    if (technician?.status === 'available' && onAssignOrder) {
      onAssignOrder(orderData, technician);
    }
  };

  return (
    <div
      className={`bg-card border border-border rounded-lg p-4 transition-all duration-200 hover:shadow-sm ${
        isDragOver ? 'border-primary bg-primary/5' : ''
      } ${technician?.status === 'available' ? 'cursor-pointer' : 'opacity-75'}`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          {/* <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center">
            <Icon name="User" size={20} className="text-muted-foreground" />
          </div> */}
          <div>
            <h3 className="font-semibold text-foreground">{technician?.name}</h3>
            {/* <p className="text-sm text-text-secondary">{technician?.employeeId}</p> */}
          </div>
        </div>
        {/* <div className={`px-2 py-1 rounded-full text-xs font-medium flex items-center space-x-1 ${getStatusColor(technician?.status)}`}>
          <Icon name={getStatusIcon(technician?.status)} size={12} />
          <span>{getStatusText(technician?.status)}</span>
        </div> */}
      </div>
      {/* Workload */}
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{technician?.currentOrders}</div>
          <div className="text-xs text-text-secondary">Aktuelle Aufträge</div>
        </div>
        <div className="text-center">
          <div className="text-lg font-semibold text-foreground">{technician?.completedToday}</div>
          <div className="text-xs text-text-secondary">Heute erledigt</div>
        </div>
      </div>
      {/* Skills */}
      {/* <div className="mb-3">
        <div className="text-xs text-text-secondary mb-1">Spezialisierungen:</div>
        <div className="flex flex-wrap gap-1">
          {technician?.skills?.slice(0, 3)?.map((skill, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md"
            >
              {skill}
            </span>
          ))}
          {technician?.skills?.length > 3 && (
            <span className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md">
              +{technician?.skills?.length - 3}
            </span>
          )}
        </div>
      </div> */}
      {/* Location */}
      {/* <div className="flex items-center space-x-2 mb-3">
        <Icon name="MapPin" size={14} className="text-text-secondary" />
        <span className="text-sm text-text-secondary">{technician?.location}</span>
        <span className="text-xs text-text-secondary">({technician?.distance})</span>
      </div> */}
      {/* Actions */}
      <div className="flex space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onViewDetails(technician)}
          className="flex-1"
        >
          <Icon name="Eye" size={14} className="mr-1" />
          Details
        </Button>
        <Button
          variant="destructive"
          size="sm"
          onClick={() => onDeleteTechnician(technician)}
          className="px-3"
        >
          <Icon name="Trash2" size={14} />
        </Button>
        {technician?.status === 'available' && (
          <Button
            variant="default"
            size="sm"
            onClick={async () => {
              if (selectedOrders && selectedOrders.length > 0) {
                // Assign all selected orders to this technician
                let successCount = 0;
                let errorCount = 0;
                
                for (const order of selectedOrders) {
                  try {
                    await onAssignOrder(order, technician);
                    successCount++;
                  } catch (error) {
                    errorCount++;
                    console.error('Error assigning order:', order.id, error);
                  }
                }
                
                // Show results
                if (successCount > 0) {
                  alert(`${successCount} Aufträge erfolgreich dem Techniker ${technician.name} zugewiesen${errorCount > 0 ? ` (${errorCount} Fehler)` : ''}`);
                  // Reload data and clear selection
                  if (onAssignmentComplete) {
                    await onAssignmentComplete();
                  }
                }
                if (errorCount > 0) {
                  alert(`${errorCount} Aufträge konnten nicht zugewiesen werden.`);
                }
              } else {
                // Show message that no orders are selected
                alert('Bitte wählen Sie zuerst Aufträge aus, die Sie diesem Techniker zuweisen möchten.');
              }
            }}
            className="flex-1"
            disabled={!selectedOrders || selectedOrders.length === 0}
          >
            <Icon name="Plus" size={14} className="mr-1" />
            {selectedOrders && selectedOrders.length > 0 
              ? `${selectedOrders.length} zuweisen` 
              : 'Zuweisen'
            }
          </Button>
        )}
      </div>

    </div>
  );
};

export default TechnicianCard;